<template>
  <component :is="component" class="item" :to="to" @click="click">
    <span>{{ label }}</span>
    <icon v-if="hasDiamond" name="nomad:diamond" size="2.2rem" />
  </component>
</template>
<script lang="ts" setup>
interface Props {
  label: string;
  to?: string;
  click?: Function | Promise<void>;
  hasDiamond?: boolean;
}
const props = defineProps({
  label: null,
  to: null,
  click: { type: Function },
  hasDiamond: { type: Boolean, default: false }
});
const component = computed(() => {
  if (props.to) {
    return resolveComponent('NuxtLink');
  }
  return 'button';
});
</script>
<style lang="scss" scoped>
.item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2.4rem;
  padding: var(--gap_l);
  transition: border-color 300ms $ease-out-quad,
    background-color 100ms $ease-out-quad, color 100ms $ease-in-quad;
  border-color: var(--color_secondary_light);
  background-color: var(--color_neutral_25);
  color: var(--color_neutral_900);
  @include stroke('m', 'm');
  &:focus,
  &:hover {
    border-color: var(--color_secondary);
    background-color: var(--color_secondary);
    color: var(--color_neutral_25);
  }
}
</style>
